import ServiceCRUD from './ServiceCRUDFLEXUC';
import { apiUc } from '../http';

class ExtensionService extends ServiceCRUD {
  constructor() {
    super('/api/ramais');
  }

  createExtensionRange(data) {
    return apiUc.post(`/api/ramais-range`, data);
  }

  updateExtensionSet(data) {
    return apiUc.put(`/api/ramais-range`, data);
  }

  getAllShowDisableNew = (showDisable) => {
    return apiUc.get(`${this.path}/all?showDisable=${showDisable}`);
  };
}

export default new ExtensionService();
